export default __webpack_public_path__ + "static/media/depannage-a-distance.46e21430.jpg";